import React from 'react';

export const StatusOkIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="16" cy="16" r="16" fill="#88CC3E" fillOpacity=".1" />
            <path
                d="m13.57 18.77-2.81-2.82a.35.35 0 0 0-.5 0l-.82.83a.35.35 0 0 0 0 .5l3.89 3.88c.13.14.35.14.5 0l8.73-8.74a.35.35 0 0 0 0-.5l-.82-.82a.35.35 0 0 0-.5 0l-7.67 7.67Z"
                fill="#88CC3E"
            />
        </svg>
    );
};
